import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17.57 3.857a1.72 1.72 0 00-1.714-1.714H2.142A1.72 1.72 0 00.428 3.857v10.286a1.72 1.72 0 001.714 1.714h13.714a1.72 1.72 0 001.715-1.714V3.857zm-1.714 0L9 8.143 2.142 3.857h13.714zM2.142 14.143h13.714V5.572L9 9.857 2.142 5.572v8.571z" fill="#54585D" /></svg>);